// Copyright (c) 2024 Deere & Company

import './factory-duplicate-pin-plate.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import FactoryDuplicatePinPlateResult from './factory-duplicate-pin-plate-result';
import FactoryPinPlate from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';
import {FormattedMessage} from 'react-intl';
import ListViewShowMore from '../../../shared/components/list-view-show-more';
import RefinableListWidget from '../../../shared/components/refinable-list-widget';
import SearchDropDown from '../../shared/state/search-by-dropdown';
import SearchFilters from '../../shared/state/search-filters';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import State from '../state';
import TabNavigation from '../../../shared/components/tab-navigation';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {getNavigationTabs} from '../../shared/services/product-navigation-helper';

const filterOptions = [
    [
        'pin'
    ],
    [
        'status'
    ],
    [
        'dealer',
        'location',
        'state'
    ]
];

const sortOptions = [
    {
        displayName: 'Default',
        path: ['default']
    },
    {
        displayName: 'PIN',
        path: ['pin']
    },
    {
        displayName: 'STATUS',
        path: [
            'status'
        ]
    }
];

class FactoryDuplicatePinPlate extends Component {

    state = {
        dateDeliveryPickerExpanded: false,
        dateRequestPickerExpanded: false,
        dealerLocationExpanded: false,
        selectedItems: {}
    };

    componentWillMount() {

        if (this.props.facets.dealerAccountsFacet.isInitialLoad || !this.props.facets.dealerAccountsFacet.selectedDealers.length) {

            this.props.actions.selectAllDealersOnInitialLoad(this.props.facets.dealerAccountsFacet.allowedDealers);

        }
        this.props.actions.updateFactoryDuplicatePinPlateResults();

    }

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    }; handleSelectChange = (id, isChecked) => {

        const selectedItems = {...this.state.selectedItems};

        selectedItems[id] = isChecked;
        this.setState({selectedItems});

        // Update the Redux store with the selected items

        this.props.actions.updateSelectedPinPlates(selectedItems);

    };

    handleProcessSelected = () => {

        const selectedIds = Object.keys(this.state.selectedItems).filter(id => this.state.selectedItems[id]);

        if (selectedIds.length > 0) {

            this.props.actions.processSelectedPinPlates(selectedIds);
            this.setState({selectedItems: {}});

        }

    };

    anyFacetsOpen = () =>
        this.state.dateRequestPickerExpanded || this.state.dealerLocationExpanded || this.state.dateDeliveryPickerExpanded;

    render() {

        const countObject = {
            dealerRecommendations: this.props.dealerRecommendationCount,
            factoryDuplicatePinPlateCount: this.props.factoryDuplicatePinPlateCount,
            machineStatusUpdates: this.props.machineStatusUpdateCount,
            productSearch: this.props.searchResultsCount,
            registrationReview: this.props.registrationReviewCount,
            transferApproval: this.props.transferApprovalsCount
        };

        let sortedCollection;

        sortedCollection = [...this.props.factoryDuplicatePinPlates];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, filterOptions, sortedCollection);

        const hasSelectedItems = Object.keys(this.state.selectedItems).some(id => this.state.selectedItems[id]);
        const list = sortedCollection.map((factoryDuplicatePinPlate, index) => {

            const pinPlateWithSelected = {
                ...factoryDuplicatePinPlate,
                selected: this.state.selectedItems[factoryDuplicatePinPlate.id] || false
            };

            return (
                <FactoryDuplicatePinPlateResult
                    actions={this.props.actions}
                    factoryDuplicatePinPlate={pinPlateWithSelected}
                    key={index}
                    onSelectChange={this.handleSelectChange}
                />
            );

        });

        return (
            <div className='registration-review'>

                <main>

                    <TabNavigation
                        tabs={getNavigationTabs(countObject, this.props.hasSearchResults, this.props.security)}
                    />
                    <div className='product-list'>
                        <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: '10px'}}>
                            <button
                                className='button-primary'
                                disabled={!hasSelectedItems}
                                onClick={this.handleProcessSelected}
                            >
                                <FormattedMessage id='MARK_AS_INPROCESS'/>
                            </button>
                        </div>
                        <RefinableListWidget
                            onFilterByChange={this.props.actions.updateListFilterBy}
                            onSortByChange={this.props.actions.updateListSortBy}
                            onSortDirectionChange={this.props.actions.updateListSortDirection}
                            searchFilters={this.props.searchFilters}
                            sortOptions={sortOptions}
                            type={State}
                        />
                        <ListViewShowMore
                            initialShowItems={50}
                            perMoreMultiplier={1.25}
                            showAllOption={true}
                            showPerMore={50}
                            totalItems={list.length}
                        >
                            {list}
                        </ListViewShowMore>
                    </div>
                </main>
            </div>
        );

    }

}

FactoryDuplicatePinPlate.displayName = 'FactoryDuplicatePinPlate';
FactoryDuplicatePinPlate.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    dateFormat: PropTypes.string.isRequired,
    dealerRecommendationCount: PropTypes.number,
    facets: PropTypes.object,
    factoryDuplicatePinPlateCount: PropTypes.number,
    factoryDuplicatePinPlates: PropTypes.arrayOf(PropTypes.instanceOf(FactoryPinPlate)).isRequired,
    hasSearchResults: PropTypes.bool.isRequired,
    machineStatusUpdateCount: PropTypes.number,
    registrationReviewCount: PropTypes.number,
    reportsRoutes: PropTypes.object.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchDropDown),
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    searchResultsCount: PropTypes.number.isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    transferApprovalsCount: PropTypes.number,
    user: PropTypes.instanceOf(User).isRequired
};

export default FactoryDuplicatePinPlate;



// WEBPACK FOOTER //
// ./src/product/factory-users-duplicate-pin-plate/components/factory-duplicate-pin-plate.js